export const DURATION_UNITS = {
  days: 'd',
  hours: 'h',
  minutes: 'm',
  seconds: 's',
} as const;
